import type { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import type { Message } from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import type { ChannelThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface PostscriptThreadViewProps {
  messages: Message[];
  supportTicketId: SupportTicketId;
  thread: ChannelThread;
}

export const PostscriptThreadView = memo(function PostscriptThreadView({
  messages,
  supportTicketId,
  thread,
}: PostscriptThreadViewProps) {
  return (
    <ChatThreadView
      channel="postscript"
      messages={messages}
      supportTicketId={supportTicketId}
      thread={thread}
    />
  );
});
